'use client';
import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import { trackEvent } from '@/lib/analytics';
import RoughAnnotation from '@/components/common/RoughAnnotation';
import { useGsapReveal } from '@/hooks/useGsapReveal';

const FinalCTA: React.FC = () => {
  const router = useRouter();
  const [email, setEmail] = useState('');
  const sectionRef = useGsapReveal<HTMLElement>({ y: 30, duration: 0.9, start: 'top 80%' });

  return (
    <section ref={sectionRef} className="final-cta py-32 px-8 relative overflow-hidden" style={{ background: 'linear-gradient(175deg, #428fe9, #3475db)' }}>
      {/* Corner scribbles — reuse Comparison pattern in white */}
      <svg className="sketch-corner sketch-corner--tl" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M2,2 Q5,3 8,2 Q11,1 14,3" stroke="white" strokeWidth="1.2" strokeLinecap="round" opacity="0.15" />
        <path d="M2,2 Q3,5 2,8 Q1,11 3,14" stroke="white" strokeWidth="1.2" strokeLinecap="round" opacity="0.15" />
      </svg>
      <svg className="sketch-corner sketch-corner--br" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M18,18 Q15,17 12,18 Q9,19 6,17" stroke="white" strokeWidth="1.2" strokeLinecap="round" opacity="0.15" />
        <path d="M18,18 Q17,15 18,12 Q19,9 17,6" stroke="white" strokeWidth="1.2" strokeLinecap="round" opacity="0.15" />
      </svg>

      <div className="max-w-3xl mx-auto text-center relative z-10">
        <h2 className="text-3xl sm:text-4xl md:text-7xl font-semibold mb-6 md:mb-8 tracking-tight text-white relative inline-block cta-h2">
          <RoughAnnotation
            type="underline"
            color="rgba(255, 255, 255, 0.5)"
            strokeWidth={2}
            padding={4}
            animationDuration={800}
            triggerOnScroll={true}
            scrollThreshold={0.2}
          >
            Ready to map your curriculum?
          </RoughAnnotation>
        </h2>
        <p className="mb-3 text-white/70 text-lg" style={{ fontFamily: 'var(--font-caveat)' }}>
          Join the league &rarr;
        </p>
        <p className="text-white/80 text-xl md:text-2xl mb-12 max-w-xl mx-auto font-normal">
          Join educators building a curriculum graph that grades, diagnoses, and intervenes — automatically.
        </p>

        <form
          onSubmit={(e) => { e.preventDefault(); trackEvent('book_demo_click', 'CTA', 'final_cta'); router.push(email ? `/book-demo?email=${encodeURIComponent(email)}` : '/book-demo'); }}
          className="max-w-md mx-auto flex flex-col sm:flex-row gap-3"
        >
          <input
            type="email"
            required
            autoComplete="email"
            aria-label="Work email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Work email address"
            className="cta-email-input input input-lg flex-1 bg-white border-white/20"
          />
          <button
            type="submit"
            className="cta-submit-btn btn btn-lg bg-white text-[#428fe9] hover:bg-white/90 font-bold"
          >
            Get Started &rarr;
          </button>
        </form>

        <p className="mt-6 text-white/70 text-sm font-medium">
          We'll reach out within 24 hours
        </p>
        <p className="mt-2 text-white/50 text-[10px] font-bold uppercase tracking-widest">
          No credit card required • Secure & Private
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;
